import { render, staticRenderFns } from "./DoughnutChartFooter.vue?vue&type=template&id=3b7ca135&scoped=true"
import script from "./DoughnutChartFooter.vue?vue&type=script&lang=js"
export * from "./DoughnutChartFooter.vue?vue&type=script&lang=js"
import style0 from "./DoughnutChartFooter.vue?vue&type=style&index=0&id=3b7ca135&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7ca135",
  null
  
)

export default component.exports